"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_json_1 = require("../config.json");
class Config {
    static async SetSqlInstance(instance) {
        this.SQLinstance = instance;
    }
    static GetSqlInstance() {
        return this.SQLinstance;
    }
    static SetCookie(cookie) {
        this.cookie = cookie;
    }
    static GetCookie() {
        return this.cookie;
    }
}
exports.default = Config;
Config.ONLINE_API_URL = config_json_1.ONLINE_API_URL;
Config.IS_ONLINE = true;
